import React from 'react';

const NotFound = () => {
    return (
        <div className="p-5">
            <h4>Sorry Page Not Found</h4>
            <h1>404!</h1>
        </div>
    );
};

export default NotFound;